import { combineEpics } from "redux-observable";
import aboutDetailsFetch from "./about-details-fetch";

export default combineEpics(aboutDetailsFetch);
